"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.eth_signTransaction = void 0;
const eth_rpc_errors_1 = __importDefault(require("eth-rpc-errors"));
// import { sign } from "@opentron/tron-sig-util";
const { ethErrors } = eth_rpc_errors_1.default;
/*
eth_signTransaction

IMPORTANT: we do not follow eth rpc spec here... we are supposed to
return an hex encoded transaction with signature but we instead return a
signed tron transaction object. Simplifies things a bit for
@opentron/tronweb-from-provider implementation. Otherwise we would have
to somehow convert the signed tron transaction to hex encoded ethereum
transaction and then re-convert to a tron transction on the receiving
end...
*/
function eth_signTransaction([txParams = {}], ctx) {
    return __awaiter(this, void 0, void 0, function* () {
        if (!ctx.privateKey) {
            throw ethErrors.rpc.methodNotSupported({
                message: `eth_sendTransaction is not supported (privateKey not passed to java-tron-provider)`,
            });
        }
        //   const signedTronTransaction = await sign(txParams, ctx.privateKey, ctx);
        //   return signedTronTransaction;
        return null;
    });
}
exports.eth_signTransaction = eth_signTransaction;
